var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.679 2.53223C15.6418 1.35736 13.7648 0.85405 11.3636 0.85405H4.39505C3.90425 0.85405 3.48714 1.20859 3.40928 1.68827L0.507616 19.9452C0.450611 20.3053 0.731466 20.6307 1.09852 20.6307H5.40033L6.48065 13.8318L6.44728 14.0459C6.52375 13.5662 6.93948 13.2117 7.43028 13.2117H9.47412C13.4909 13.2117 16.6345 11.5933 17.5536 6.9119C17.5814 6.77286 17.6245 6.50591 17.6245 6.50591C17.8858 4.77351 17.623 3.59864 16.679 2.53223Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7131 7.39299C17.7148 12.0021 14.5295 14.4408 9.47407 14.4408H7.64156L6.27344 23.1H9.24605C9.67568 23.1 10.0413 22.79 10.1081 22.3687L10.1428 22.1852L10.8269 17.8875L10.8714 17.6512C10.9381 17.2299 11.3038 16.9198 11.732 16.9198H12.2757C15.7891 16.9198 18.5393 15.5044 19.3429 11.4098C19.6655 9.76635 19.5098 8.3885 18.7131 7.39299Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/Paypal.2f08a9cd8e3b5154df5a851860034b5c.svg";
export { ForwardRef as ReactComponent };